(function () {
  if (customElements.get('quantity-breaks')) return;

  class QuantityBreaks extends HTMLElement {
    constructor() {
      super();

      this.items = [];
      this.selectedItem = null;
      this.productForm = null;
      this.quantityInput = null;
    }

    connectedCallback() {
      this.items = Array.from(
        this.querySelectorAll('[data-ref="quantity-break-item"]')
      );

      if (!this.items.length) return;

      this.productForm = this.getProductForm();

      if (this.productForm) {
        this.quantityInput =
          this.productForm.querySelector('input[name="quantity"]');

        if (!this.quantityInput) {
          this.quantityInput = document.createElement('input');
          this.quantityInput.type = 'hidden';
          this.quantityInput.name = 'quantity';
          this.productForm.appendChild(this.quantityInput);
        }
      }

      this.items.forEach((item) => {
        item.addEventListener('click', () => {
          this.selectItem(item);
        });
      });

      const defaultPack =
        parseInt(this.dataset.defaultPack, 10) || 1;

      const defaultItem =
        this.items.find((item) => {
          return (
            parseInt(item.dataset.packMonths, 10) ===
            defaultPack
          );
        }) || this.items[0];

      this.selectItem(defaultItem, false);

    }

    getProductForm() {
      const closestForm = this.closest(
        'form[action*="/cart/add"]'
      );

      if (closestForm) return closestForm;

      const section = this.closest(
        '[id^="shopify-section-"]'
      );

      if (section) {
        const form = section.querySelector(
          'form[action*="/cart/add"]'
        );

        if (form) return form;
      }

      return document.querySelector(
        'form[action*="/cart/add"]'
      );
    }

    selectItem(item, notify = true) {
      if (!item) return;

      this.items.forEach((currentItem) => {
        currentItem.classList.remove('quantity-break--selected');
        currentItem.setAttribute('aria-pressed', 'false');
      });

      item.classList.add('quantity-break--selected');
      item.setAttribute('aria-pressed', 'true');


      this.selectedItem = item;

      const quantity =
        parseInt(item.dataset.quantity, 10) || 1;

      if (this.quantityInput) {
        this.quantityInput.value = quantity;

        this.quantityInput.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }
      
      this.updateThemePrices();
      if (notify) {
        document.dispatchEvent(
          new CustomEvent('quantity-breaks:updated', {
            detail: {
              quantity,
              packMonths:
                parseInt(
                  item.dataset.packMonths,
                  10
                ) || quantity,
              item,
              quantityBreaks: this
            }
          })
        );
      }
    }

    getSelectedQuantity() {
      return this.selectedItem;
    }

    getQuantity() {
      return (
        parseInt(
          this.selectedItem?.dataset.quantity,
          10
        ) || 1
      );
    }

    getPackMonths() {
      return (
        parseInt(
          this.selectedItem?.dataset.packMonths,
          10
        ) || this.getQuantity()
      );
    }

    getPrices() {
      if (!this.selectedItem) {
        return {
          price: 0,
          compareAtPrice: 0
        };
      }

      return {
        price:
          parseInt(
            this.selectedItem.dataset.totalPrice,
            10
          ) || 0,

        compareAtPrice:
          parseInt(
            this.selectedItem.dataset
              .totalCompareAtPrice,
            10
          ) || 0
      };
    }

    getSelectedItems() {
      if (!this.selectedItem) return [];

      return [
        {
          id: this.selectedItem.dataset.variantId,
          quantity: this.getQuantity()
        }
      ];
    }
    updateThemePrices() {
      if (!this.selectedItem) return;

      const price =
        parseInt(
          this.selectedItem.dataset.totalPrice,
          10
        ) || 0;

      const compareAtPrice =
        parseInt(
          this.selectedItem.dataset.totalCompareAtPrice,
          10
        ) || price;

      const quantity =
        parseInt(
          this.selectedItem.dataset.quantity,
          10
        ) || 1;

      const variantId =
        this.selectedItem.dataset.variantId || '';

      const formatMoney = (cents) => {
        return new Intl.NumberFormat('fr-FR', {
          style: 'currency',
          currency: 'EUR'
        }).format(cents / 100);
      };

      const formattedPrice =
        formatMoney(price);

      const formattedCompareAtPrice =
        formatMoney(compareAtPrice);


      /* =========================================
        1. PRIX PRINCIPAL DE LA FICHE PRODUIT
      ========================================= */

      const productPrice =
        document.querySelector('#ProductPrice');

      const comparePrice =
        document.querySelector('#ComparePrice');

      const compareWrapper =
        comparePrice?.closest(
          '.product-single__price--wrapper'
        );

      if (productPrice) {
        productPrice.textContent =
          formattedPrice;

        productPrice.setAttribute(
          'content',
          (price / 100).toFixed(2)
        );
      }

      if (comparePrice) {
        if (compareAtPrice > price) {
          comparePrice.textContent =
            formattedCompareAtPrice;

          comparePrice.style.display = '';

          if (compareWrapper) {
            compareWrapper.setAttribute(
              'aria-hidden',
              'false'
            );
          }
        } else {
          comparePrice.textContent = '';
          comparePrice.style.display = 'none';

          if (compareWrapper) {
            compareWrapper.setAttribute(
              'aria-hidden',
              'true'
            );
          }
        }
      }


      /* =========================================
        2. BOUTON ATC PRINCIPAL
      ========================================= */

      const mainAtcButton =
        document.querySelector(
          '.product-single__add-to-cart button[name="add"]'
        );

      if (mainAtcButton) {
        /*
        * On mémorise le texte d'origine une seule fois.
        *
        * Exemple :
        * "Ajouter au panier - 29,90 €"
        * devient comme base :
        * "Ajouter au panier"
        */
        if (!mainAtcButton.dataset.baseText) {
          const currentText =
            mainAtcButton.textContent
              .trim();

          mainAtcButton.dataset.baseText =
            currentText
              .replace(
                /\s*-\s*[\d\s,.]+(?:€|EUR).*$/i,
                ''
              )
              .trim() ||
            'Ajouter au panier';
        }

        mainAtcButton.textContent =
          `${mainAtcButton.dataset.baseText} - ${formattedPrice}`;
      }


      /* =========================================
        3. QUANTITÉ DU FORMULAIRE PRINCIPAL
      ========================================= */

      if (this.quantityInput) {
        this.quantityInput.value =
          quantity;
      }


      /* =========================================
        4. STICKY ATC
      ========================================= */

      const stickyForm =
        document.querySelector(
          '#AddToCartForm--atc-sticky'
        );

      /*
      * Mise à jour du texte du bouton sticky
      */
      const stickyAtcButton =
        document.querySelector(
          '#AddToCart--atc-sticky'
        );

      if (stickyAtcButton) {
        const stickyText =
          stickyAtcButton.querySelector(
            '.btn__text'
          );

        if (stickyText) {
          stickyText.textContent =
            `Ajouter - ${formattedPrice}`;
        } else {
          stickyAtcButton.textContent =
            `Ajouter - ${formattedPrice}`;
        }
      }
      const selectedPackImage =
        this.selectedItem.querySelector(
          '[data-ref="quantity-break-image"]'
        );

      const stickyImage =
        document.querySelector(
          '#atcsticky .image_wrapper img'
        );

      if (selectedPackImage && stickyImage) {
        const imageUrl =
          selectedPackImage.currentSrc ||
          selectedPackImage.src;

        if (imageUrl) {
          stickyImage.src = imageUrl;
          stickyImage.dataset.src = imageUrl;
          stickyImage.srcset = '';

          /*
          * Ton thème utilise lazyload.
          * On évite qu'il réinjecte ensuite
          * l'ancienne image.
          */
          stickyImage.classList.add(
            'lazyloaded'
          );

          stickyImage.classList.remove(
            'lazyload'
          );
        }

        if (selectedPackImage.alt) {
          stickyImage.alt =
            selectedPackImage.alt;
        }
      }
      if (stickyForm) {

        /*
        * Variante Shopify
        */
        const stickyVariantSelect =
          stickyForm.querySelector(
            'select[name="id"], input[name="id"]'
          );

        if (
          stickyVariantSelect &&
          variantId
        ) {
          stickyVariantSelect.value =
            variantId;

          stickyVariantSelect.dispatchEvent(
            new Event('change', {
              bubbles: true
            })
          );
        }

        /*
        * Quantité
        */
        let stickyQuantityInput =
          stickyForm.querySelector(
            'input[name="quantity"]'
          );

        if (!stickyQuantityInput) {
          stickyQuantityInput =
            document.createElement('input');

          stickyQuantityInput.type =
            'hidden';

          stickyQuantityInput.name =
            'quantity';

          stickyForm.appendChild(
            stickyQuantityInput
          );
        }

        stickyQuantityInput.value =
          quantity;

        /*
        * Selling plan
        */
        const mainProductForm =
          this.productForm;

        const mainSellingPlan =
          mainProductForm?.querySelector(
            '[name="selling_plan"]'
          );

        let stickySellingPlan =
          stickyForm.querySelector(
            '[name="selling_plan"]'
          );

        if (!stickySellingPlan) {
          stickySellingPlan =
            document.createElement('input');

          stickySellingPlan.type =
            'hidden';

          stickySellingPlan.name =
            'selling_plan';

          stickyForm.appendChild(
            stickySellingPlan
          );
        }

        stickySellingPlan.value =
          mainSellingPlan?.value || '';
      }



      document.dispatchEvent(
        new CustomEvent(
          'glx:product-price-updated',
          {
            detail: {
              price,
              compareAtPrice,
              quantity,
              variantId
            }
          }
        )
      );
    }
  }

  customElements.define(
    'quantity-breaks',
    QuantityBreaks
  );
})();